import {Dialog, type DialogProps} from '@mui/material';
import type {ReactNode} from 'react';
import React from 'react';

export interface ModalProps extends Omit<DialogProps, 'title' | 'onClose'> {
    open: boolean;
    onClose: () => void;
    /** feste Breite des Papers (Default 616) */
    width?: number | string;
    children: ReactNode;
}

export function Modal({open, onClose, width = 616, children, ...rest}: ModalProps) {
    return (
        <Dialog
            open={open}
            onClose={(_, reason) => {
                // Backdrop/Esc weiterhin erlaubt – nur ein einheitliches onClose nach außen
                if (reason !== 'backdropClick') onClose();
                else onClose();
            }}
            {...rest}
            slotProps={{
                paper: {
                    sx: {
                        width,
                        maxWidth: '100%',
                        m: 2,
                        borderRadius: 2,
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                        // flache MUI-Elevation statt Glanzverlauf
                        boxShadow:
                            '0 11px 15px -7px rgba(0,0,0,.2), 0 24px 38px 3px rgba(0,0,0,.14)',
                    },
                },
            }}
        >
            {children}
        </Dialog>
    );
}